// theme.js - Core functionality for ICONWALL on Shopify

document.addEventListener('DOMContentLoaded', () => {
    const cartIcon = document.getElementById('cart-icon');
    const closeCartBtn = document.getElementById('close-cart');
    const cartDrawer = document.getElementById('cart-drawer');
    const cartOverlay = document.getElementById('cart-overlay');
    const cartItemsContainer = document.querySelector('.cart-drawer .overflow-y-auto');
    const cartCountBadge = document.getElementById('cart-count');
    const cartSubtotal = document.getElementById('cart-subtotal');

    const runtime = JSON.parse(document.getElementById('iconwall-runtime').textContent);
    const messages = runtime.messages;
    const root = runtime.root.replace(/\/?$/, '/');
    const status = document.getElementById('cart-status');
    const checkout = document.querySelector('.cart-drawer button.bg-gold-gradient');
    let cartPending = false;
    let cartReady = false;
    let cartQuantity = 0;
    async function request(url, options) {
        const response = await fetch(url, options);
        if (!response.ok) throw new Error(response.status === 422 ? messages.unavailable : messages.error);
        return response.json();
    }
    const productForm = document.querySelector('[data-product-form]');
    const primaryAddButton = document.getElementById('product-add-btn');
    const stickyBar = document.querySelector('[data-sticky-product]');
    const stickyAddButton = document.querySelector('[data-sticky-add]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    function selectedProductVariant() {
        return productForm?.querySelector('input.variant-selector:checked') || productForm?.querySelector('input.variant-selector[type="hidden"]');
    }
    function syncProductVariant() {
        const selected = selectedProductVariant();
        if (!selected || !primaryAddButton) return;
        primaryAddButton.dataset.variantId = selected.value;
        const unavailable = selected.dataset.available === 'false';
        primaryAddButton.disabled = cartPending || unavailable;
        if (stickyAddButton) stickyAddButton.disabled = cartPending || unavailable;
        if (stickyPrice && selected.dataset.price) stickyPrice.textContent = selected.dataset.price;
    }
    function showAddError(scope, message) {
        const error = scope.querySelector('[data-add-error]');
        if (error) { error.textContent = message; error.hidden = !message; }
        if (scope === productForm) {
            const stickyError = stickyBar?.querySelector('[data-sticky-error]');
            if (stickyError) { stickyError.textContent = message; stickyError.hidden = !message; }
        }
    }
    function busy(value, message = '') {
        cartPending = value;
        cartDrawer?.setAttribute('aria-busy', String(value));
        if (status) status.textContent = message;
        cartItemsContainer?.querySelectorAll('button').forEach(button => { button.disabled = value; });
        document.querySelectorAll('.add-to-cart-btn').forEach(button => {
            if (value) { button.dataset.wasDisabled = String(button.disabled); button.disabled = true; }
            else if ('wasDisabled' in button.dataset) { button.disabled = button.dataset.wasDisabled === 'true'; delete button.dataset.wasDisabled; }
        });
        stickyAddButton?.setAttribute('aria-busy', String(value));
        syncProductVariant();
        if (checkout) checkout.disabled = value || !cartReady || cartQuantity === 0;
    }
    const money = (cents) => (cents / 100).toLocaleString(runtime.locale, { style: 'currency', currency: runtime.currency || 'EUR' });
    const escapeHTML = (value) => String(value || '').replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));

    function openCart() {
        if (cartDrawer && cartOverlay) {
            cartDrawer.classList.add('open');
            cartOverlay.classList.add('open');
            document.body.style.overflow = 'hidden';
        }
    }

    function closeCart() {
        if (cartDrawer && cartOverlay) {
            cartDrawer.classList.remove('open');
            cartOverlay.classList.remove('open');
            document.body.style.overflow = '';
        }
    }

    if (cartIcon) cartIcon.addEventListener('click', (event) => { event.preventDefault(); openCart(); if (!cartPending) fetchCart().catch(() => {}); });
    if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

    function updateCartUI(cart) {
        cartQuantity = cart?.item_count || 0;
        if (!cartItemsContainer) return;
        cartItemsContainer.innerHTML = '';

        if (!cart || cart.item_count === 0) {
            cartItemsContainer.innerHTML = '<div class="text-center text-gray-500 mt-10">Il tuo carrello è vuoto.</div>';
        } else {
            cart.items.forEach((item) => {
                const itemEl = document.createElement('div');
                itemEl.className = 'flex gap-4 items-center bg-dark p-3 rounded border border-dark-border mb-4';
                itemEl.innerHTML = `
                    ${item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" class="w-20 h-20 object-cover rounded">` : '<div class="w-20 h-20 bg-dark-card rounded flex items-center justify-center text-xs text-gold">IW</div>'}
                    <div class="flex-1">
                        <h4 class="text-sm font-bold">${escapeHTML(item.product_title)}</h4>
                        <p class="text-xs text-gray-400">${escapeHTML(item.variant_title || '')}</p>
                        <div class="flex justify-between items-center mt-2">
                            <div class="flex items-center border border-dark-border rounded">
                                <button class="px-2 py-1 hover:bg-dark-border dec-qty" data-line="${escapeHTML(item.key)}" data-qty="${item.quantity}" aria-label="Diminuisci quantità">-</button>
                                <span class="px-2 text-sm">${item.quantity}</span>
                                <button class="px-2 py-1 hover:bg-dark-border inc-qty" data-line="${escapeHTML(item.key)}" data-qty="${item.quantity}" aria-label="Aumenta quantità">+</button>
                            </div>
                            <span class="font-bold text-gold">${money(item.line_price)}</span>
                        </div>
                    </div>
                `;
                cartItemsContainer.appendChild(itemEl);
            });
        }

        if (cartCountBadge) {
            cartCountBadge.innerText = cart ? cart.item_count : 0;
            cartCountBadge.classList.toggle('hidden', !cart || cart.item_count === 0);
        }
        if (cartSubtotal) cartSubtotal.innerText = money(cart ? cart.total_price : 0);

        cartItemsContainer.querySelectorAll('.dec-qty').forEach((btn) => {
            btn.addEventListener('click', function () {
                changeCartItem(this.getAttribute('data-line'), Math.max(parseInt(this.getAttribute('data-qty'), 10) - 1, 0));
            });
        });
        cartItemsContainer.querySelectorAll('.inc-qty').forEach((btn) => {
            btn.addEventListener('click', function () {
                changeCartItem(this.getAttribute('data-line'), parseInt(this.getAttribute('data-qty'), 10) + 1);
            });
        });
    }

    async function loadCart() {
        const cart = await request(root + 'cart.js');
        updateCartUI(cart);
        cartReady = true;
    }
    async function fetchCart() {
        if (cartPending) return;
        busy(true, messages.loading);
        let message = '';
        try { await loadCart(); }
        catch (error) { cartReady = false; message = messages.refresh_error; throw error; }
        finally { busy(false, message); }
    }
    async function changeCartItem(line, quantity) {
        if (cartPending) return;
        busy(true, messages.updating);
        let message = '';
        try {
            const cart = await request(root + 'cart/change.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: line, quantity })
            });
            updateCartUI(cart);
            cartReady = true;
        } catch (error) { cartReady = false; message = messages.refresh_error; }
        finally { busy(false, message); }
    }
    fetchCart().catch(() => {});

    document.querySelectorAll('[data-product-form] input.variant-selector').forEach((input) => {
        input.addEventListener('change', function () {
            const form = this.closest('[data-product-form]');
            if (!form) return;
            const selected = form.querySelector('input.variant-selector:checked') || form.querySelector('input.variant-selector[type="hidden"]');
            const button = form.querySelector('.add-to-cart-btn');
            const priceEl = form.querySelector('#product-price');
            const comparePriceEl = form.querySelector('#product-compare-price');
            if (selected && button) syncProductVariant();
            showAddError(form, '');
            if (selected && priceEl && selected.dataset.price) priceEl.innerText = selected.dataset.price;
            if (selected && comparePriceEl) {
                const hasDiscount = selected.dataset.hasDiscount === 'true';
                comparePriceEl.innerText = hasDiscount ? selected.dataset.comparePrice : '';
                comparePriceEl.classList.toggle('hidden', !hasDiscount);
            }
        });
    });

    if (primaryAddButton && stickyBar && stickyAddButton) {
        syncProductVariant();
        stickyAddButton.addEventListener('click', () => {
            if (!stickyAddButton.disabled) primaryAddButton.click();
        });
        const setStickyVisibility = (visible) => {
            const show = visible && window.matchMedia('(max-width: 767px)').matches;
            stickyBar.classList.toggle('is-visible', show);
            stickyBar.setAttribute('aria-hidden', String(!show));
            document.body.classList.toggle('iw-sticky-active', show);
        };
        if ('IntersectionObserver' in window) {
            let primaryVisible = false;
            const observer = new IntersectionObserver(([entry]) => {
                primaryVisible = entry.isIntersecting;
                setStickyVisibility(!primaryVisible);
            });
            observer.observe(primaryAddButton);
            window.addEventListener('resize', () => setStickyVisibility(!primaryVisible));
        } else {
            const refreshSticky = () => {
                const rect = primaryAddButton.getBoundingClientRect();
                setStickyVisibility(rect.bottom < 0 || rect.top > window.innerHeight);
            };
            window.addEventListener('scroll', refreshSticky, { passive: true });
            window.addEventListener('resize', refreshSticky);
            refreshSticky();
        }
    }

    document.addEventListener('click', async function (event) {
        const btn = event.target.closest('.add-to-cart-btn');
        if (!btn) return;
        event.preventDefault();
        if (btn.disabled || btn.dataset.loading === 'true') return;

        const scope = btn.closest('[data-product-form]') || btn.closest('.product-card') || document;
        const selectedVariant = scope.querySelector('input.variant-selector:checked') || scope.querySelector('input.variant-selector[type="hidden"]');
        const variantId = selectedVariant ? selectedVariant.value : btn.getAttribute('data-variant-id');

        if (!variantId) {
            showAddError(scope, messages.select_variant);
            return;
        }

        if (cartPending) return;
        showAddError(scope, '');
        busy(true, messages.adding);
        btn.dataset.loading = 'true';
        btn.setAttribute('aria-busy', 'true');
        let message = '';
        let added = false;
        try {
            await request(root + 'cart/add.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
            });
            added = true;
            await loadCart();
            message = messages.added;
            showAddError(scope, '');
            openCart();
        } catch (error) {
            cartReady = false;
            message = added ? messages.refresh_error : error.message;
            showAddError(scope, message);
            if (added || !scope.querySelector('[data-add-error]')) openCart();
        } finally {
            btn.dataset.loading = 'false';
            btn.removeAttribute('aria-busy');
            busy(false, message);
        }
    });

    const checkoutBtn = document.querySelector('.cart-drawer button.bg-gold-gradient');
    if (checkoutBtn) checkoutBtn.addEventListener('click', () => { if (cartPending || !cartReady || !cartQuantity) return; window.location.href = root + 'checkout'; });

    const mainProductImage = document.getElementById('main-product-image');
    const thumbnails = document.querySelectorAll('.gallery-thumbnail');
    if (mainProductImage && thumbnails.length > 0) {
        thumbnails.forEach((thumb) => {
            thumb.closest('button').addEventListener('click', function () {
                thumbnails.forEach((t) => t.classList.remove('ring-2', 'ring-gold'));
                thumb.classList.add('ring-2', 'ring-gold');
                mainProductImage.src = thumb.dataset.full || thumb.src;
                mainProductImage.alt = thumb.alt;
            });
        });
    }

    const header = document.getElementById('main-header');
    if (header) {
        window.addEventListener('scroll', () => {
            header.classList.toggle('shadow-lg', window.scrollY > 50);
            header.classList.toggle('backdrop-blur-md', window.scrollY > 50);
        });
    }

    const mobileToggle = document.getElementById('mobile-menu-toggle');
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileClose = document.getElementById('mobile-menu-close');
    if (mobileToggle && mobileMenu) mobileToggle.addEventListener('click', () => mobileMenu.classList.add('open'));
    if (mobileClose && mobileMenu) mobileClose.addEventListener('click', () => mobileMenu.classList.remove('open'));

    document.querySelectorAll('[data-search-wrapper]').forEach((searchWrapper) => {
        const searchInput = searchWrapper.querySelector('[data-search-input]');
        const searchResults = searchWrapper.querySelector('[data-search-results]');
        let searchTimeout = null;
        let searchController;
        let searchVersion = 0;
        searchResults.setAttribute('aria-live', 'polite');

        if (!searchInput || !searchResults) return;

        searchInput.addEventListener('input', function () {
            const query = this.value.trim();
            clearTimeout(searchTimeout);
            searchController?.abort();
            const version = ++searchVersion;
            searchResults.setAttribute('aria-busy', 'false');
            searchResults.innerHTML = '';

            if (query.length < 2) {
                searchResults.classList.add('hidden');
                return;
            }

            searchResults.classList.remove('hidden');
            searchResults.textContent = messages.loading;
            searchResults.setAttribute('aria-busy', 'true');
            searchTimeout = setTimeout(() => {
                searchController = new AbortController();
                request(`${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`, { signal: searchController.signal })
                    .then((data) => {
                        if (version !== searchVersion) return;
                        const products = data.resources && data.resources.results ? data.resources.results.products : [];
                        searchResults.innerHTML = '';
                        if (!products.length) {
                            searchResults.textContent = messages.empty;
                        } else {
                            products.forEach((product) => {
                                const item = document.createElement('a');
                                item.href = product.url;
                                item.className = 'flex items-center gap-3 p-3 hover:bg-dark-border transition-colors border-b border-dark-border last:border-0';
                                item.innerHTML = `
                                    ${product.image ? `<img src="${escapeHTML(product.image)}" alt="${escapeHTML(product.title)}" class="w-12 h-12 object-cover rounded">` : '<div class="w-12 h-12 bg-dark rounded flex items-center justify-center text-xs text-gold">IW</div>'}
                                    <div class="flex-1">
                                        <h4 class="text-white text-sm font-bold">${escapeHTML(product.title)}</h4>
                                        <span class="text-gold text-xs">Vedi prodotto</span>
                                    </div>
                                `;
                                searchResults.appendChild(item);
                            });
                        }
                        searchResults.classList.remove('hidden');
                    })
                    .catch((error) => { if (version === searchVersion && error.name !== 'AbortError') searchResults.textContent = messages.search_error; })
                    .finally(() => { if (version === searchVersion) searchResults.setAttribute('aria-busy', 'false'); });
            }, 250);
        });

        document.addEventListener('click', function (event) {
            if (!searchWrapper.contains(event.target)) { clearTimeout(searchTimeout); searchController?.abort(); searchVersion++; searchResults.setAttribute('aria-busy', 'false'); searchResults.classList.add('hidden'); }
        });
    });

    const priceFilter = document.getElementById('price-filter');
    const priceDisplay = document.getElementById('price-display');
    const productCards = document.querySelectorAll('.product-card[data-price]');
    if (priceFilter && priceDisplay) {
        priceFilter.addEventListener('input', function () {
            const maxPrice = parseInt(this.value, 10);
            priceDisplay.innerText = '€' + maxPrice;
            productCards.forEach((card) => {
                const cardPrice = parseFloat(card.getAttribute('data-price')) || 0;
                card.classList.toggle('hidden', cardPrice > maxPrice);
            });
        });
    }
});
